import { render, staticRenderFns } from "./CreateCategory.vue?vue&type=template&id=5a585f93&"
import script from "./CreateCategory.vue?vue&type=script&lang=js&"
export * from "./CreateCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateCategory.vue"
export default component.exports